var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "soli-round" },
    [
      _c(
        "v-container",
        { staticClass: "px-3", attrs: { fluid: "" } },
        [
          _c("ReportHeader", {
            attrs: {
              filter: "",
              subtitle: `${_vm.$page.props.auth.user.selected_location.name} Lesson History`,
              selectedLocation: _vm.$page.props.auth.user.selected_location,
              dateRange: _vm.dateRange,
              reportUrl: `/profile/${this.user.id}/attendance`,
              params: { viewNotes: Number(_vm.viewNotes) },
              dateOptions: "past, upcoming, month, year",
            },
            on: {
              loading: function ($event) {
                _vm.loading = $event
              },
              search: function ($event) {
                _vm.search = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "filterItem",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex flex-col pb-1" },
                      [
                        _c(
                          "v-list-item",
                          { staticClass: "flex justify-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "flex soli-round soli-grey",
                                attrs: { ripple: false, outlined: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.$inertia.reload({
                                      data: {
                                        viewNotes: Number(!_vm.viewNotes),
                                      },
                                    })
                                  },
                                },
                              },
                              [
                                _c("small", { staticClass: "mr-2" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s("View Attendance Notes") +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: _vm.viewNotes ? "accent" : null,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.viewNotes
                                          ? "toggle_on"
                                          : "toggle_off"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item",
                          { staticClass: "flex justify-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "flex soli-round soli-grey",
                                attrs: { ripple: false, outlined: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.$inertia.reload({
                                      data: {
                                        viewCreditEligible: Number(
                                          !_vm.viewCreditEligible
                                        ),
                                      },
                                    })
                                  },
                                },
                              },
                              [
                                _c("small", { staticClass: "mr-2" }, [
                                  _vm._v("View Credit-Eligible"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: _vm.viewCreditEligible
                                        ? "accent"
                                        : null,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.viewCreditEligible
                                          ? "toggle_on"
                                          : "toggle_off"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          !_vm.attendances
            ? _c("v-skeleton-loader", {
                staticClass: "mb-6 pl-1 pt-2",
                staticStyle: { "max-width": "600px" },
                attrs: {
                  type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line,list-item-avatar-three-line",
                  boilerplate: "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.attendances
            ? _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.attendances,
                  "hide-default-footer": "",
                  "disable-pagination": "",
                  "no-data-text": "No lessons found",
                  search: _vm.search,
                  loading: _vm.loading,
                  "disable-sort": _vm.$vuetify.breakpoint.xs,
                },
                on: {
                  "click:row": function ($event) {
                    return _vm.$log($event.id)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.lesson.starts_at`,
                      fn: function ({ item }) {
                        return [
                          _c("AttendanceDate", {
                            attrs: { date: item.lesson.starts_at },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.lesson.details`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "py-4" },
                            [
                              _c("AttendanceInfo", {
                                attrs: { attendance: item },
                              }),
                              _vm._v(" "),
                              _c("AttendanceTitle", {
                                attrs: { attendance: item },
                              }),
                              _vm._v(" "),
                              _c("AttendanceLesson", {
                                attrs: { lesson: item.lesson },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.purchaseOption.name`,
                      fn: function ({ item }) {
                        return [
                          _c("AttendanceOption", {
                            attrs: {
                              attendance: item,
                              purchaseOption: item.purchaseOption,
                            },
                            on: {
                              success: function ($event) {
                                return _vm.$emit("success")
                              },
                              reset: function ($event) {
                                return _vm.$emit("reset")
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.status`,
                      fn: function ({ item }) {
                        return [
                          _c("AttendanceStatus", {
                            attrs: { attendance: item, student: _vm.user },
                            on: {
                              success: function ($event) {
                                return _vm.$emit("success")
                              },
                              reset: function ($event) {
                                return _vm.$emit("reset")
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.lesson_note`,
                      fn: function ({ item }) {
                        return [
                          _c("TipTapReader", {
                            staticClass: "mt-4",
                            attrs: { value: item.lesson_note },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.practice_note`,
                      fn: function ({ item }) {
                        return [
                          _c("TipTapReader", {
                            staticClass: "mt-4",
                            attrs: { value: item.practice_note },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }